export default function isValidate(constraint, value) {
    if (constraint == "fileSize") {
        if (value > 2048) {
            return false;
        }
    }

    if (constraint == "AttachedfileSize") {
        if (value > 25600) {
            return false;
        }
    }

    if (constraint === "filesAttach") {
        if (value > 5) {
            return false;
        }
    }
    if (constraint === "subject") {
        if (!value || value.trim() === "") {
            return false;
        }
    }
    if (constraint === "editorContent") {
        if (!value || value.trim() === "") {
            return false;
        }
    }

    return true;
}
